import {all} from 'redux-saga/effects';
import watcherSaga from './dashboardSaga';
import loginWatcherSaga from './loginSaga';
import watchingAnalyticsSaga from './analyticsSaga';
import watcherPassSaga from './confrimPassSaga';
import addEmpWatcherSaga from './EmpSaga';
import watcherAccessSaga from './accessCardSaga';
import vmsSocketSaga from './socketSaga';
import blocklistWatcherSaga from './blocklistSaga';

export default function* rootSaga() {
  yield all([
    watcherSaga(),
    loginWatcherSaga(),
    watchingAnalyticsSaga(),
    watcherPassSaga(),
    addEmpWatcherSaga(),
    watcherAccessSaga(),
    vmsSocketSaga(),
    blocklistWatcherSaga(),
  ])
}
